import { Button } from "./ui/button";
import { resolveRetiredAppInfo } from "../config/retiredApp";

interface RetiredAppNoticeProps {
  hostName?: string;
}

export function RetiredAppNotice({ hostName }: RetiredAppNoticeProps) {
  const info = resolveRetiredAppInfo(hostName);
  const requiredVersion = info.minVersion
    ? `${info.hostName} ${info.minVersion} or newer`
    : `the latest version of ${info.hostName}`;

  return (
    <div className="flex min-h-screen w-full items-center justify-center px-8 py-10 font-sans text-foreground">
      <div className="flex w-full max-w-xs flex-col items-center gap-5 text-center">
        <div
          aria-hidden="true"
          className="flex size-14 items-center justify-center rounded-full bg-muted text-muted-foreground"
        >
          <svg
            viewBox="0 0 24 24"
            className="size-7"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.75"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <circle cx="12" cy="12" r="9" />
            <path d="M12 7.5v5" />
            <path d="M12 16.5h.01" />
          </svg>
        </div>

        <div className="flex flex-col gap-2">
          <h1 className="text-lg font-semibold leading-snug">
            Assistant retired
          </h1>
          <p className="prose-text text-sm leading-relaxed text-muted-foreground">
            Trimble Assistant for {info.hostName} is no longer supported.
          </p>
        </div>

        <p className="prose-text text-sm leading-relaxed">
          Update to {requiredVersion} to access the new Civil Design Assistant.
        </p>

        {info.releaseNotesUrl && (
          <Button
            variant="primary"
            variantStyle="outline"
            className="h-auto min-h-10 whitespace-normal py-2 text-center"
            render={
              <a
                href={info.releaseNotesUrl}
                target="_blank"
                rel="noopener noreferrer"
              />
            }
            nativeButton={false}
          >
            {info.linkLabel ?? "View release notes"}
          </Button>
        )}
      </div>
    </div>
  );
}
